import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import { generatePath } from "react-router";
import DownIcon from "@material-ui/icons/KeyboardArrowDown";
import classnames from "classnames";
import { connect } from "react-redux";
import { Dialog } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import Cookie from "js-cookie";
import axios from "axios";

import { report } from "../../../services/reportServices";
import Button from "../../Button";
import sitemap from "../../../routing/siteMap";
import AdvancedAvatar from "../../AdvancedAvatar/AdvancedAvatar";
import CommonButton from "../../Button";
import FollowArtist from "../../FollowArtist";
import { CONFIG } from "../../../constants";
import store from "../../../redux";
import { showGlobalSnack } from "../../../redux/actions/snack.actions";
import {
    get,
    getWithAuth,
    postData,
} from "../../../services/generalApiServices";

import "./artist.scss";

const mapStateToProps = (state) => ({
    user: state.user,
});
const dialogClasses = {
    paper: {
        width: "100%",
        maxWidth: 280,
        padding: 20,
    },
};

class ArtistSideBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isBioOpen: false,
            showAllText: false,
            showAllAchiev: false,
            styles: [],
            showReport: false,
            reportValue: "",
            reportOpt: "",
            showInput: false,
            otherText: "",
            showBlock: false,
        };
    }
    token = Cookie.get(CONFIG.AUTH_TOKEN);
    handelBioShow = () => {
        this.setState((prevState) => ({
            isBioOpen: !prevState.isBioOpen,
        }));
    };
    componentDidMount() {
        const { artist } = this.props;
        if (artist?.info?.categories?.length > 0) {
            const tempArray = artist?.info?.categories?.filter(
                (v, i, a) => a.findIndex((t) => t._id === v._id) === i
            );
            this.setState({ styles: tempArray });
        }
        this.getReportOptions();
    }
    handleChange = (e) => {
        this.setState({ reportValue: e.target.value });
        if (e.target.value === "61cd60b2d9cf90805f719a2c") {
            this.setState({ showInput: true });
        }
    };
    closeDialog = () => {
        this.setState({ showReport: false, showBlock: false });
    };
    getReportOptions = () => {
        get(
            CONFIG.GET_REPORT_OPTIONS,
            (options) => {
                this.setState({ reportOpt: options });
            },
            (err) => {}
        );
    };

    handleSubmit = () => {
        const { reportValue, otherText } = this.state;
        if (reportValue) {
            report(
                generatePath(CONFIG.REPORT_USER, {
                    id: this.props.artist?._id,
                }),
                (res) => {
                    store.dispatch(
                        showGlobalSnack(
                            "success",
                            "Profile reported successfully",
                            3000
                        )
                    );
                    this.setState({ showReport: false });
                },
                (err) => {
                    store.dispatch(showGlobalSnack("error", err, 3000));
                    this.setState({ showReport: false });
                },
                {
                    category: reportValue,
                    content: otherText,
                }
            );
        } else {
            store.dispatch(
                showGlobalSnack(
                    "error",
                    "Please Select option to continue",
                    3000
                )
            );
        }
    };
    blockUser = (id) => {
        const { history } = this.props;
        const token = Cookie.get(CONFIG.AUTH_TOKEN);
        const apiUrl = generatePath(CONFIG.BLOCK_USER, { id });
        if (token) {
            axios({
                url: apiUrl,
                method: "PATCH",
                headers: {
                    Authorization: `JWT ${token}`,
                },
            })
                .then((response) => {
                    if (response.data.status === "succes") {
                        this.setState({ showBlock: false });
                        store.dispatch(
                            showGlobalSnack(
                                "success",
                                "Artist blocked successfully",
                                3000
                            )
                        );
                        history.push("/privacy");
                    } else throw new Error(response.data.message);
                })
                .catch((e) => {
                    this.setState({ showBlock: false });
                    store.dispatch(
                        showGlobalSnack(
                            "error",
                            "Something went wrong while blocking artist",
                            3000
                        )
                    );
                });
        }
    };

    initChat = () => {
        const { user, artist } = this.props;
        postData(
            CONFIG.CREATE_ROOM,
            (res) => {

                this.props.history.push(
                    `${
                        user
                            ? generatePath(sitemap.messages, {
                                  to: res?.room?._id,
                              })
                            : sitemap.login
                    }`
                );
            },
            (e) => console.log(e, "error creating room"),
            { sender: user.id, receiver: artist._id }
        );
    };
    render() {
        const {
            isBioOpen,
            styles,
            showReport,
            reportOpt,
            reportValue,
            showInput,
            showBlock,
        } = this.state;
        const { artist, artistId, readOnly, user, classes,setFollow } = this.props;

        const bioClass = classnames("sideBarGroup bioSideBarGroup", {
            "bio-showing": isBioOpen,
        });
        const image = "assets/profile-dummy.png";
        const categoryList = styles.map((category) => {
            return (
                <li key={`category-item-${category._id}`}>
                    <NavLink to="#" className="active">
                        {category.name}
                    </NavLink>
                </li>
            );
        });
        return (
            <div className="gridItem artistSideBar" id="sidebar">
                <Dialog
                    open={showReport}
                    onClose={this.closeDialog}
                    aria-labelledby="responsive-dialog-title"
                    classes={classes}
                >
                    <div id="responsive-dialog-title">Report Profile</div>
                    <FormControl component="fieldset">
                        <RadioGroup
                            aria-label="report"
                            name="report"
                            disabled="true"
                            value={reportValue}
                            onChange={this.handleChange}
                        >
                            {reportOpt &&
                                reportOpt.map((opt) => (
                                    <FormControlLabel
                                        value={opt?._id}
                                        control={<Radio />}
                                        label={<div>{opt?.name}</div>}
                                    />
                                ))}
                        </RadioGroup>
                        {showInput && (
                            <input
                                placeholder="write reason"
                                className="report-input"
                                onChange={(e) =>
                                    this.setState({ otherText: e.target.value })
                                }
                            />
                        )}
                    </FormControl>
                    <div className="report-btns">
                        <Button mode="reportSubmit" onClick={this.handleSubmit}>
                            Submit
                        </Button>
                        <Button mode="special" onClick={this.closeDialog}>
                            Cancel
                        </Button>
                    </div>
                </Dialog>
                <Dialog
                    open={showBlock}
                    onClose={this.closeDialog}
                    aria-labelledby="responsive-dialog-title"
                    classes={classes}
                >
                    <div id="responsive-dialog-title">Block User</div>
                    <div
                        id="responsive-dialog-actions"
                        style={{ marginTop: "14px" }}
                    >
                        <span
                            role="button"
                            tabIndex="-1"
                            onClick={() => this.blockUser(artist?._id)}
                            mode="special"
                        >
                            Confirm
                        </span>
                        <Button
                            size="medium"
                            onClick={this.closeDialog}
                            mode="specialBlack"
                        >
                            Cancel
                        </Button>
                    </div>
                </Dialog>
                <div className="inner">
                    <div className="sideBarGroup profileSideBarGroup">
                        <div className="sideGroupContent">
                            <div className="sideBarItem artistContainer">
                                <AdvancedAvatar
                                    name={artist?.name}
                                    imgPath={
                                        artist?.picture &&
                                        artist.picture != "undefined"
                                            ? `users/${artist?.picture}`
                                            : image
                                    }
                                    followers={String(artist?.follows?.length)}
                                    works={String(artist?.products?.length)}
                                    id={artist?._id}
                                    category={artist?.info?.categories[0]?.name}
                                    verified={artist?.verifiedArtist}
                                />

                                <div className="action">
                                    {artist &&
                                    user &&
                                    artist?._id === user?.id ? (
                                        <ul>
                                            <li>
                                                <NavLink
                                                    to={sitemap.cart}
                                                    activeClassName="active"
                                                >
                                                    <button className="cart-btn">
                                                        Cart
                                                    </button>
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to={generatePath(
                                                        sitemap.studiolikedArtwork,
                                                        {
                                                            slug: user?.slug,
                                                        }
                                                    )}
                                                    activeClassName="active"
                                                >
                                                    <button className="saved-btn">
                                                        Liked
                                                    </button>
                                                </NavLink>
                                            </li>
                                        </ul>
                                    ) : (
                                        <ul>
                                            <li>
                                                <FollowArtist artist={artist} setFollow={setFollow} />
                                            </li>
                                            <li>
                                                {artist?.slug && (
                                                    <div
                                                        // to={
                                                        //     user
                                                        //         ? generatePath(
                                                        //               sitemap.messages,
                                                        //               {
                                                        //                   to:
                                                        //                       artist?._id,
                                                        //               }
                                                        //           )
                                                        //         : sitemap.login
                                                        // }
                                                        onClick={() =>
                                                            this.initChat()
                                                        }
                                                    >
                                                        <CommonButton
                                                            size="medium"
                                                            mode="special"
                                                        >
                                                            Message
                                                        </CommonButton>
                                                    </div>
                                                )}
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={bioClass}>
                        <div className="sideGroupContent">
                            {artist?.info?.categories?.length > 0 && (
                                <div className="sideBarItem">
                                    <div className="title">
                                        <h6>Styles</h6>
                                    </div>
                                    <div className="styles">
                                        <ul>{categoryList}</ul>
                                    </div>
                                </div>
                            )}

                            {artist?.info?.biography &&
                                artist?.info?.biography !== "undefined" && (
                                    <div className="sideBarItem bioContainer">
                                        <div className="title">
                                            <h6>Biography</h6>
                                        </div>
                                        <div className="content">
                                            <p
                                                className={`bio ${this.state
                                                    .showAllText &&
                                                    "view-all"}`}
                                            >
                                                {artist?.info?.biography.slice(
                                                    0,
                                                    132
                                                )}
                                                {this.state.showAllText &&
                                                    artist?.info?.biography.slice(
                                                        132
                                                    )}
                                                {artist?.info?.biography
                                                    .length > 132 && (
                                                    <>
                                                        <span
                                                            onClick={() =>
                                                                this.setState({
                                                                    showAllText: !this
                                                                        .state
                                                                        .showAllText,
                                                                })
                                                            }
                                                        >
                                                            {!this.state
                                                                .showAllText
                                                                ? " .... Read More"
                                                                : " Read Less"}
                                                        </span>
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            {artist?.info?.achievements &&
                                artist?.info?.achievements !== "undefined" && (
                                    <div className="sideBarItem bioContainer">
                                        <div className="title">
                                            <h6>Achievements</h6>
                                        </div>
                                        <div className="content">
                                            <p
                                                className={`bio ${this.state
                                                    .showAllAchiev &&
                                                    "view-all"}`}
                                            >
                                                {artist?.info?.achievements.slice(
                                                    0,
                                                    132
                                                )}

                                                {this.state.showAllAchiev &&
                                                    artist?.info?.achievements.slice(
                                                        132
                                                    )}
                                                {artist?.info?.achievements
                                                    .length > 132 && (
                                                    <>
                                                        <span
                                                            onClick={() =>
                                                                this.setState({
                                                                    showAllAchiev: !this
                                                                        .state
                                                                        .showAllAchiev,
                                                                })
                                                            }
                                                        >
                                                            {!this.state
                                                                .showAllAchiev
                                                                ? " .... Read More"
                                                                : " Read Less"}
                                                        </span>
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>

                    <div className="sideGroupAction">
                        <DownIcon onClick={this.handelBioShow} />
                    </div>
                    {user?.id !== artist?._id && (
                        <div className="report-profile">
                            <span
                                className="pro-report"
                                onClick={() =>
                                    this.setState({ showReport: true })
                                }
                            >
                                Report
                            </span>
                            <span
                                className="pro-block"
                                onClick={() =>
                                    this.setState({ showBlock: true })
                                }
                            >
                                Block
                            </span>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

ArtistSideBar.propTypes = {
    artist: PropTypes.objectOf(PropTypes.any).isRequired,
    readOnly: PropTypes.bool,
    user: PropTypes.objectOf(PropTypes.any),
};
ArtistSideBar.defaultProps = {
    readOnly: true,
    user: null,
};

export default connect(mapStateToProps)(
    withStyles(dialogClasses)(ArtistSideBar)
);
